import type { ColumnsType, ColumnType } from 'antd/es/table';

export type PartitionedColumns<T> = {
  fixedLeft: ColumnsType<T>;
  reorderable: ColumnsType<T>;
  fixedRight: ColumnsType<T>;
};

export const partitionColumns = <T>(
  columns: ColumnsType<T>
): PartitionedColumns<T> => {
  const fixedLeft: ColumnsType<T> = [];
  const reorderable: ColumnsType<T> = [];
  const fixedRight: ColumnsType<T> = [];

  columns.forEach(col => {
    const fixed = (col as ColumnType<T>).fixed;

    if (fixed === 'left' || fixed === true) {
      fixedLeft.push(col);
    } else if (fixed === 'right') {
      fixedRight.push(col);
    } else {
      reorderable.push(col);
    }
  });

  return { fixedLeft, reorderable, fixedRight };
};

export const applyColumnOrder = <T>(
  reorderable: ColumnsType<T>,
  columnOrder: string[] | undefined
): ColumnsType<T> => {
  if (!columnOrder?.length) return reorderable;

  const byKey = new Map<string, ColumnsType<T>[number]>();

  reorderable.forEach(col => {
    const key = (col as ColumnType<T>).key;

    if (key !== undefined && key !== null) {
      byKey.set(String(key), col);
    }
  });

  const ordered: ColumnsType<T> = [];
  const used = new Set<string>();

  columnOrder.forEach(key => {
    const col = byKey.get(key);

    if (col) {
      ordered.push(col);
      used.add(key);
    }
  });

  reorderable.forEach(col => {
    const key = (col as ColumnType<T>).key;

    if (key === undefined || key === null || !used.has(String(key))) {
      ordered.push(col);
    }
  });

  return ordered;
};
